window.GTM_applyVideoEvents = function() {
	this.on('firstplay', function() {
		dataLayer.push({
		  'event': 'ga_event',
		  'eventData': {
		    'category': 'Video',
		    'action': 'start',
		    'label': this.cache_.src,
		    'value': 0
      }
    });
	});
	this.on('pause', function() {
		dataLayer.push({
		'event': 'ga_event',
		'eventData': {
		  'category': 'Video',
		  'action': 'pause',
		  'label': this.cache_.src,
		  'value': 0
      }
    });
	});
	this.on('ended', function() {
		dataLayer.push({
		  'event': 'ga_event',
		  'eventData': {
		    'category': 'Video',
		    'action': 'end',
		    'label': this.cache_.src,
		    'value': 0
      }
    });
	});
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/gtm-event/video-events.js